import Lodge from "../../pages/lodge/Lodge";

export default function AdminView() {
  return <Lodge />
}